import React from "react";

// @mui component:
import type { TableContainerProps } from "@mui/material";
import XTableContainer from "@mui/material/TableContainer";

const TableContainer: React.FC<TableContainerProps> = (props) => {

  return <XTableContainer {...props}>{props.children}</XTableContainer>

};

export default TableContainer;
